var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParticipantsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6709",
    "data-name": "Group 6709",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.027,
    height: 29.027,
    viewBox: "0 0 29.027 29.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6470",
    "data-name": "Group 6470",
    transform: "translate(7.87 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53399",
    "data-name": "Path 53399",
    d: "M1033.3,479.487a3.444,3.444,0,0,0-.069.724c0,.6.119,1.086.267,1.086.071,0,.134-.113.182-.294a4.649,4.649,0,0,0,.875,1.385l0,.008a1.837,1.837,0,0,0,1.645,1.049h1.635a1.836,1.836,0,0,0,1.644-1.049l0-.008a4.638,4.638,0,0,0,.838-1.289c.042.124.1.2.153.2.147,0,.267-.487.267-1.087a4.013,4.013,0,0,0-.031-.5,5.788,5.788,0,0,0,.062-.8,3.966,3.966,0,0,0-3.2-5.2,3.913,3.913,0,0,0-3.233,1,3.98,3.98,0,0,0-1.072,4.194A5.386,5.386,0,0,0,1033.3,479.487Z",
    transform: "translate(-1030.41 -473.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53400",
    "data-name": "Path 53400",
    d: "M1041.9,489.8a9.831,9.831,0,0,0-1.272-.828,5.248,5.248,0,0,1-1.658-1.079l0-.005a1.555,1.555,0,0,0-1.127-.584h-3.28a1.551,1.551,0,0,0-1.125.583l-.006.007a5.26,5.26,0,0,1-1.658,1.079,9.752,9.752,0,0,0-1.272.828,2.648,2.648,0,0,0-.911,1.373h13.276l.011-.027A5.1,5.1,0,0,0,1041.9,489.8Z",
    transform: "translate(-1029.591 -476.896)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6471",
    "data-name": "Group 6471",
    transform: "translate(0 14.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53401",
    "data-name": "Path 53401",
    d: "M1023,498.8a3.49,3.49,0,0,0-.07.724c0,.6.12,1.086.267,1.086.07,0,.134-.113.182-.294a4.663,4.663,0,0,0,.875,1.385l0,.008a1.836,1.836,0,0,0,1.644,1.05h1.635a1.837,1.837,0,0,0,1.645-1.05l0-.008a4.638,4.638,0,0,0,.838-1.289c.043.124.1.2.153.2.148,0,.267-.487.267-1.087a4.012,4.012,0,0,0-.031-.5,5.9,5.9,0,0,0,.061-.8,3.966,3.966,0,0,0-3.2-5.2,3.913,3.913,0,0,0-3.234,1,3.98,3.98,0,0,0-1.072,4.194A5.607,5.607,0,0,0,1023,498.8Z",
    transform: "translate(-1020.107 -492.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53402",
    "data-name": "Path 53402",
    d: "M1031.6,509.11a9.741,9.741,0,0,0-1.272-.827,5.258,5.258,0,0,1-1.657-1.08l-.005-.005a1.554,1.554,0,0,0-1.126-.584h-3.28a1.553,1.553,0,0,0-1.126.583l-.006.007a5.24,5.24,0,0,1-1.658,1.079,9.786,9.786,0,0,0-1.271.828,2.649,2.649,0,0,0-.911,1.373h13.276l.011-.027A5.117,5.117,0,0,0,1031.6,509.11Z",
    transform: "translate(-1019.288 -496.21)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6472",
    "data-name": "Group 6472",
    transform: "translate(15.739 14.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53403",
    "data-name": "Path 53403",
    d: "M1043.6,498.8a3.389,3.389,0,0,0-.07.724c0,.6.119,1.086.267,1.086.07,0,.134-.113.182-.294a4.668,4.668,0,0,0,.875,1.385l0,.008a1.837,1.837,0,0,0,1.644,1.05h1.635a1.836,1.836,0,0,0,1.644-1.05l0-.008a4.622,4.622,0,0,0,.838-1.289c.043.124.1.2.153.2.147,0,.267-.487.267-1.087a4.012,4.012,0,0,0-.031-.5,5.675,5.675,0,0,0,.061-.8,3.966,3.966,0,0,0-3.2-5.2,3.913,3.913,0,0,0-3.234,1,3.98,3.98,0,0,0-1.072,4.194A5.386,5.386,0,0,0,1043.6,498.8Z",
    transform: "translate(-1040.712 -492.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53404",
    "data-name": "Path 53404",
    d: "M1052.206,509.11a9.79,9.79,0,0,0-1.271-.827,5.255,5.255,0,0,1-1.658-1.08l-.005-.005a1.554,1.554,0,0,0-1.126-.584h-3.28a1.554,1.554,0,0,0-1.126.583l-.006.007a5.245,5.245,0,0,1-1.658,1.079,9.74,9.74,0,0,0-1.272.828,2.649,2.649,0,0,0-.911,1.373h13.277l.011-.027A5.081,5.081,0,0,0,1052.206,509.11Z",
    transform: "translate(-1039.893 -496.21)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantsIcon);
export default __webpack_public_path__ + "static/media/ParticipantsIcon.b3f0d43fe0457535360a8aa06e736b5f.svg";
export { ForwardRef as ReactComponent };